//components
import { useTheme, Box } from '@mui/material';

export default function FormIcon({ icon }) {
	const theme = useTheme();

	return (
		<Box
			sx={{
				width: '32px',
				height: '32px',
				borderRadius: '50%',
				background: theme.palette.root.brandPrimary_008,
				marginRight: '10px',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			{icon}
		</Box>
	);
}
